<template>
  <Modal>
    <Modal.Title>Move {{ ids.length }} items</Modal.Title>
    <Modal.Body>
      Are you sure you want to move {{ ids.length }} items to
      <span class="font-medium">{{ folder.name }}</span
      >?
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="stroke"
        :size="isMobile ? 'lg' : 'md'"
        :disabled="loading"
        @click="close()"
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        :loading="loading"
        @click="handleClick"
      >
        Okay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'
import type { Folder } from '@/shared/graphql/router/graphql'
import { useDevice } from '@/shared/composables/useDevice'

const { close, closeAll } = useModal()
const { isMobile } = useDevice()

const props = defineProps<{
  folder: Folder
  ids: string[]
  callback: () => Promise<void>
}>()

const loading = ref(false)

const handleClick = async () => {
  loading.value = true
  await props.callback()
  closeAll()
}
</script>
